import { Inject } from "typescript-ioc";
import { UiComponent } from "Ui/Scripts/UiComponent";
import { UiComponentFactory } from "Ui/Scripts/UiComponentFactory";
import { EventBinder } from "Events/Scripts/EventBinder";
import { LoggerFactory } from "Logging/Scripts/LoggerFactory";
import { LoadArticlesView } from "./LoadArticlesView";
import { Utils } from "Helpers/Scripts/Utils";
import { Device } from "Rwd/Scripts/Device";

export class LoadArticles extends UiComponent {
    private _view: LoadArticlesView;
    private _device: Device;

    public get key(): string {
        return "LoadArticles";
    }

    constructor(
        @Inject componentFactory: UiComponentFactory,
        @Inject binder: EventBinder,
        @Inject loggerFactory: LoggerFactory,
        @Inject device: Device
    ) {
        super(componentFactory, binder, loggerFactory);
        this._device = device;
    }

    public init(): void {
        this._view = this.createComponent(LoadArticlesView);
        this.showArticles();
        this._view.loadMore.bindClick(this.loadMoreArticles.bind(this));
    }

    /**
     * Updates articles visibility
     */
    private showArticles(): void {
        const articlesInRow =
            this._device.activeBreakpointIndex > this._view.MAX_MOBILE_BREAKPOINT_INDEX
                ? this._view.DESKTOP_ARTICLES_IN_ROW
                : this._view.MOBILE_ARTICLES_IN_ROW;
        const articlesToShow = this._view.rowsToShow * articlesInRow;
        const articles = this._view.articles.find(this._view.ARTICLE_ITEM);

        articles.forEach((article, index) => {
            if (index < articlesToShow) {
                Utils.removeClass(article, this.CLASS_HIDDEN);
            }
        });

        if (articlesToShow >= articles.length) {
            this._view.loadMore.addClass(this.CLASS_HIDDEN);
        } else {
            this._view.loadMore.removeClass(this.CLASS_HIDDEN);
        }
    }

    /**
     * Increments rows to show
     */
    private loadMoreArticles(): void {
        this._view.rowsToShow += this._view.rowsToLoad;
        this.showArticles();
    }
}
